import type { FC } from "react";
import { useSelector } from "react-redux";
import { SignupForm } from "../forms/SignupForm";
import { getTermsAccepted } from "../../store/auth";
import { AcceptTerms } from "./AcceptTerms";

export const SignupFormHandler: FC = () => {
  const accepted = useSelector(getTermsAccepted);
  if (accepted) {
    return <SignupForm />;
  }
  return <AcceptTerms />;
};
